const NOT = (x) => ~x;
export default NOT;
